module.exports = __webpack_public_path__ + "img/Coworking.8b5cefd4.png";